<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <div class="contents">
        <b-form @submit.prevent="passes(onSubmit)">
          <div class="row g-0 table-type header-col">
            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.title") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="text" placeholder="" v-model="form.title" required />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.grade") }}</span>
            </div>
            <div class="col-sm-8">
              <select class="form-select-lg" v-model="form.grade" required>
                <option value="0" disabled>
                  {{ $t("title.admin.grade") }}
                </option>
                <option
                  :value="index + 1"
                  v-for="(val, index) in Array(10)"
                  :key="index + 's'"
                >
                  {{ index + 1 }}
                </option>
              </select>
            </div>

            <div class="col-sm-4">
              <span class="required">small {{ $t("title.common.image") }}</span>
            </div>
            <div class="col-sm-8 d-block">
              <div class="d-flex flex-column flex-sm-row flex-grow-1">
                <div class="flex-shrink-0 me-0 me-sm-2 mb-2 mb-sm-0">
                  <img :src="_filename | get_img" class="avatar avatar-lg" />
                </div>

                <div class="flex-grow-1">
                  <b-form-file
                    v-model="file1"
                    ref="file1"
                    :state="Boolean(file1)"
                    :placeholder="$t('text.tournament.select_file_or_drop')"
                    :drop-placeholder="$t('text.tournament.drop_it_here')"
                    @change="fileSelect"
                  >
                  </b-form-file>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <span class="required">full {{ $t("title.common.image") }}</span>
            </div>
            <div class="col-sm-8 d-block">
              <div class="d-flex flex-column flex-sm-row flex-grow-1">
                <div class="flex-shrink-0 me-0 me-sm-2 mb-2 mb-sm-0">
                  <img :src="_filename2 | get_img" class="avatar avatar-lg" />
                </div>

                <div class="flex-grow-1">
                  <b-form-file
                    v-model="file2"
                    ref="file2"
                    :state="Boolean(file2)"
                    :placeholder="$t('text.tournament.select_file_or_drop')"
                    :drop-placeholder="$t('text.tournament.drop_it_here')"
                    @change="fileSelect2"
                  >
                  </b-form-file>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <span>{{ $t("title.common.memo") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="text" placeholder="" v-model="form.memo" />
            </div>
          </div>

          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              :aria-label="$t('button.common.list')"
              @click="$router.push({ name: 'BadgeList' })"
              >{{ $t("button.common.list") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              :aria-label="$t('button.common.save')"
              type="submit"
              >{{ $t("button.common.save") }}</b-button
            >
          </div>
        </b-form>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import "@/filter/common";

import { ValidationObserver } from "vee-validate";

import ax from "@/api/manager";

export default {
  name: "BadgeWrite",
  components: {
    ValidationObserver,
  },
  data() {
    return {
      form: {
        title: "",
        grade: 0,
        filename: "",
        filename2: "",
        memo: "",
      },
      _filename: "",
      _filename2: "",
      badge_pk: this.$route.params.badge_pk || 0,
      file1: null,
    };
  },
  methods: {
    fileSelect(e) {
      // alert(e.dataTransfer.files[0]);
      if (e.dataTransfer) {
        this.form.filename = e.dataTransfer.files[0];
      } else {
        this.form.filename = e.target.files[0];
      }
    },
    fileSelect2(e) {
      // alert(e.dataTransfer.files[0]);
      if (e.dataTransfer) {
        this.form.filename2 = e.dataTransfer.files[0];
      } else {
        this.form.filename2 = e.target.files[0];
      }
    },
    onSubmit() {
      // 등록
      ax.set_badge(this.form, this.badge_pk, (flag, data) => {
        if (flag) {
          alert(data.message);
          this.$router.push({ name: "BadgeList" });
        } else {
          alert(data.message);
          return false;
        }
      });
    },
    getView() {
      ax.get_badgeview(this.badge_pk, (flag, data) => {
        if (flag) {
          this.form = data.badgeinfo;
          this._filename = data.badgeinfo.filename;
          this._filename2 = data.badgeinfo.filename2;
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    if (this.badge_pk) {
      this.getView();
    }
  },
};
</script>
